class ChatUtility {
  buildBubbleRequest(lastMessage, replyText, selectedIndex) {
    const state = lastMessage.content.state;
    const parentMeta = lastMessage.content.message?.metadata || {};
    const optionCreateTicketMap = parentMeta.optionCreateTicketMap || {};
    const options = lastMessage.content.form?.options || [];

    let createTicket = false;
    if (
      selectedIndex != null &&
      options[selectedIndex] === replyText &&
      optionCreateTicketMap[String(selectedIndex)] === true
    ) {
      createTicket = true;
    }

    let messageBody = {
      message: {
        id: "" + new Date().getTime() + Math.random(),
        text: replyText,
        type: 1, //msg.data.type, bubble always gives a text back!
        metadata: {
          body: replyText,
          createTicket,
          msgId: lastMessage.id,
        },
      },
    };
    if (state) {
      messageBody.state = state;
    }
    return messageBody;
  }
}

export default new ChatUtility();
